import type { UpdateWages } from '@web/onboarding/Checklist/onboardingChecklist.types';
import type { RestangularEmployee } from '@web/onboarding/Checklist/DefineWagesModal/defineWagesModal.types';
import useSubmitWages from '@web/onboarding/Checklist/DefineWagesModal/hooks/useSubmitWages';
import useDefineWagesForEmployeesForm from '@web/onboarding/Checklist/DefineWagesModal/hooks/useDefineWagesForEmployeesForm';
import { mapEmployeesFromRestangularToEmployeeOnboardingModel } from '@web/onboarding/Checklist/DefineWagesModal/defineWagesModal.utils';

type Props = {
  employees: RestangularEmployee[];
  updateWages: UpdateWages;
  afterSubmitCallback: () => void;
};
const useEmployeesWages = ({ employees, updateWages, afterSubmitCallback }: Props) => {
  const mappedEmployees = mapEmployeesFromRestangularToEmployeeOnboardingModel(employees);
  const { fields, dirty, errors, submit } = useDefineWagesForEmployeesForm(
    mappedEmployees,
    updateWages
  );

  const submitWages = useSubmitWages(submit, afterSubmitCallback);

  return { fields, dirty, errors, submitWages };
};

export default useEmployeesWages;
